export function convertMinutesToHoursAndMinutes(duration, type) {
  let numericMinutes;
  if (
    typeof duration === "string" &&
    duration.includes("m") &&
    duration.includes("s")
  ) {
    return duration;
  }
  // Handling based on type
  if (type === "string") {
    // For string type, always convert to hours/minutes
    if (typeof duration === "string" && /^\d+m\s\d+s$/.test(duration)) {
      // "65m 5s" format - ignore seconds, convert to minutes
      const minutesPart = duration.split("m")[0];
      numericMinutes = parseInt(minutesPart, 10);
    } else if (typeof duration === "string" && /^\d+$/.test(duration)) {
      // Pure number string
      numericMinutes = parseInt(duration, 10);
    } else {
      return "0min";
    }

    // Calculate hours and remaining minutes
    const hours = Math.floor(numericMinutes / 60);
    const remainingMinutes = numericMinutes % 60;

    // Format the output based on hours and minutes
    if (hours === 0) {
      return `${remainingMinutes}m`;
    } else if (remainingMinutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${remainingMinutes}m`;
    }
  } else if (type === "number") {
    // For number type, convert to seconds or minutes/seconds
    const numValue = Number(duration);

    if (isNaN(numValue)) return "0min";

    // If less than 60, return as seconds
    if (numValue < 60) {
      return `${numValue}s`;
    }

    // If between 60 and 3600, convert to minutes and seconds
    const minutes = Math.floor(numValue / 60);
    const seconds = numValue % 60;

    if (seconds === 0) {
      return `${minutes}m`;
    } else {
      return `${minutes}m ${seconds}s`;
    }
  } else {
    return "0min";
  }
}
